export const FETCH_REFERRAL_PROGRAMS = 'FETCH_REFERRAL_PROGRAMS';
export const FETCH_REFERRAL_PROGRAMS_LOADING = 'FETCH_REFERRAL_PROGRAMS_LOADING';
export const FETCH_REFERRAL_PROGRAMS_ERROR = 'FETCH_REFERRAL_PROGRAMS_ERROR';

export const FETCH_REFERRAL_PROGRAM_BY_ID = 'FETCH_REFERRAL_PROGRAM_BY_ID';
export const FETCH_REFERRAL_PROGRAM_BY_ID_LOADING = 'FETCH_REFERRAL_PROGRAM_BY_ID_LOADING';
export const FETCH_REFERRAL_PROGRAM_BY_ID_ERROR = 'FETCH_REFERRAL_PROGRAM_BY_ID_ERROR';

export const SET_FILTERS = 'SET_FILTERS';
export const RESET_FILTERS = 'RESET_FILTERS';
export const SET_SORT_PARAMS = 'SET_SORT_PARAMS';
export const SET_PAGINATION = 'SET_PAGINATION';
export const RESET_PAGINATION = 'RESET_PAGINATION';
